import scrollContainer from './components/scroll-container';
import salesTaxCalculator from './components/blocks/sales-tax-calculator';
import carousel from './components/blocks/carousel';
import accordion from './components/blocks/accordion';
import forms from './components/forms';
import navigation from './components/navigation';

window.jQuery = window.$ = jQuery;
document.addEventListener('DOMContentLoaded', function () {
	scrollContainer();
	salesTaxCalculator();
	carousel();
	accordion();
	forms();
	navigation();
});
